export const backendUrl = 'https://easyvideosearch.herokuapp.com';
//https://easyvideosearch.herokuapp.com
//http://localhost:5000